<template>
	<div>
		<el-dialog
			title="提示"
			:visible="printShow"
			width="420px"
			@close="close"
			center>
			<div class="print-tips">
				<div>您需要下载并安装控件才能打印，确认下载？</div>
				<div class="help">已下载，查看如何安装？</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="close">取 消</el-button>
				<el-button type="primary" @click="downLoadFile">确 定</el-button>
			</span>
			</el-dialog>
	</div>
</template>

<script>
export default {
		props: ['printShow'],
		data() {
			return {}
		},
    methods: {
			downLoadFile() {
				window.open('https://star-android-patient.oss-cn-shenzhen.aliyuncs.com/dycj/Lodop_Clodop.exe', '_blank');
			},
			close() {
				this.$emit('update:printShow', false);
			}
		},
}
</script>

<style lang="scss" scoped>
.print-tips {
  text-align: center;
  font-size: 14px;
  .help {
    font-size: 12px;
    color: #666666;
    text-decoration:underline;
    margin-top: 20px;
    cursor: pointer;
  }
}
</style>

